import React from 'react'
import classNames from 'classnames'
import { ConnectedProps } from 'react-redux'

import enhance from './enhance'
import HistoryButtons from 'screens/HistoryButtons'
import { TopBarAccessibility } from './TopBarAccessibility'

export type TopBarLabelProps = ConnectedProps<typeof enhance>

const TopBarLabel = ({
  readOnly,
  isArchived,
  isPublic,
  isChannel,
  templateId,
  onPublicBadgeClick,
}: TopBarLabelProps) => (
  <div
    className={classNames(
      'flexbox flexbox-align-center margin-right-normal',
      'font-weight-medium line-height-normal no-break-word'
    )}
  >
    <HistoryButtons />
    {!templateId && (
      <TopBarAccessibility
        readOnly={readOnly}
        isArchived={isArchived}
        isPublic={isPublic}
        isChannel={isChannel}
        onPublicBadgeClick={onPublicBadgeClick}
      />
    )}
  </div>
)

export const EnhancedTopBarLabel = enhance(TopBarLabel)
